import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_translate.svg';
import Icon, { IconProps } from './icon';

const IconTranslate = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconTranslate;
